import { useState, ReactNode } from "react"

import { ContentObjectItem } from "@vertesia/common"
import { motion } from "framer-motion"
import { X } from "lucide-react"

import { ProjectSelectionSearchPanel } from "@/components/panels/selection/ProjectSelectionSearchPanel"
import { Button } from "@ui/button"
import { DocumentSearchProvider } from "@/plugins/providers/document/DocumentSearchProvider"

import { DynamicColumn } from "@/models/datatable"
import { FilterLogic, FilterProperty } from "@/models/facets"
import { ReportSearchField } from "@/models/report"

interface ProjectSelectionOverlayProps {
    children?: ReactNode
    types: string[]
    filters: FilterProperty[]
    searches: ReportSearchField[]
    columns: DynamicColumn[]
    filters_logic: FilterLogic[]
    onObjMultipleSelection: (documents: ContentObjectItem[]) => void
}
export function ProjectSelectionOverlay({ children, types, filters, searches, columns, filters_logic, onObjMultipleSelection }: Readonly<ProjectSelectionOverlayProps>) {
    const [isOpen, setIsOpen] = useState(false)

    const handleOnMultipleSelection = (documents: ContentObjectItem[]) => {
        onObjMultipleSelection(documents)
        setIsOpen(false)
    }

    return (
        <div className="flex items-center justify-center">
            <div onClick={() => setIsOpen(true)} className="w-full align-left">
                {children}
            </div>
            {
                isOpen && (
                    <div className="z-60 fixed w-full inset-0 bg-opacity-50 flex justify-end top-0">
                        <motion.div
                            initial={{ y: "100%" }}
                            animate={{ y: 0 }}
                            exit={{ y: "0%" }}
                            transition={{ type: "spring", stiffness: 300, damping: 30 }}
                            className="w-80 h-full w-full bg-white shadow-lg p-0 relative"
                        >
                            <DocumentSearchProvider facets={searches}>
                                <ProjectSelectionSearchPanel types={types} searches={searches} filters={filters} columns={columns} filters_logic={filters_logic} onMultipleSelection={handleOnMultipleSelection}>
                                    <Button
                                        onClick={() => setIsOpen(false)}
                                        variant="outline"
                                    >
                                        <X />
                                    </Button>
                                </ProjectSelectionSearchPanel>
                            </DocumentSearchProvider>
                        </motion.div>
                    </div>
                )
            }
        </div>
    )
}